/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { mobileColumns, desktopColumns, closedColumns } from "./columns";
import { Empty } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";
import { useMedia } from "hooks/useMedia";
import { useQuery } from "@apollo/client";
import { SEARCH_USER_TASKS_QUERY } from "graphql/queries";
import { DefaultTable, FilterSideViewComponent } from "components/core";
import { SplitViewComponent, UserTaskFilters } from "components";
import UserTaskViewDrawer from "components/user-task-details";

var singletonUserTaskPleaseSaveTimer = null;

const defaultVariables = (
  appId: string,
  organizationId: string,
  archived: boolean,
) => {
  return {
    appId: appId,
    query: "",
    organizationId: null,
    limit: 10,
    offset: 0,
    archived: archived,
    sortOrder: ["-createdAt", "-dueDateTime"],
    patientId: "clz1lwvux000008l9cdgq0ol9",
    assignedUserId: null,
    assignedUserGroupId: null,
    status: null,
    tags: [],
    userTags: [],
    systemTags: [],
  };
};
  
const UserTasksTable = (props: any) => {
  const { archived, taskConfig, widgetSettings } = props;
  const { organizationId, appId, hideFilter } = widgetSettings;
  //const canManagePolicy = {}; //todo
  //const currentAccount = {}; //todo
  const taskId = taskConfig?.id;
  //let productCode = widgetSettings.productCode;
  const { isMobile } = useMedia();
  const canViewNotesWidget = false; //todofeatureFlags?.some((item) => item.key === 'NOTES_CREATION');


  const defVars = {
    ...defaultVariables(appId, organizationId, archived),
    statuses: ["IN_PROGRESS", "CREATED"],
  };

  
  const drawerContainerRef = useRef();
  const [variables, setVariables] = useState(defVars);
  const [taskDrawerOpen, setShowTaskDrawer] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [showSidebar, setShowSidebar] = useState(true);
  const [dataSource, setDataSource] = useState([]);
  const [userTaskId, setUserTaskId] = useState();
  const [taskDrawerItem, setTaskDrawerItem] = useState(null);
  const [drawerExpanded, setDrawerExpanded] = useState(false);
  const [userTaskPageSettings, setUserTaskPageSettings] = useState([]);
  const [itsTimeToSave, setItsTimeToSave] = useState(false);
  const [shouldShowCreateNotes, setShouldCreateNotes] = useState<boolean>(true);

  const resetTheTimer = () => {
    setItsTimeToSave(false);
    clearTimeout(singletonUserTaskPleaseSaveTimer);
    singletonUserTaskPleaseSaveTimer = setTimeout(
      () => setItsTimeToSave(true),
      5 * 60 * 1000,
    );
  };

  const stopTheTimer = () => {
    clearTimeout(singletonUserTaskPleaseSaveTimer);
    setItsTimeToSave(false);
  };

  const openTaskDrawer = (itemId) => {
    setUserTaskId(itemId);
    setTaskDrawerItem(itemId);
    setShowTaskDrawer(true);
    // setShowSidebar(false);
    resetTheTimer();
  };


  const closeTaskDrawer = () => {
    setTaskDrawerItem(null);
    setShowTaskDrawer(false);
    stopTheTimer();
  };

  const afterUpdate = (closeTheDrawer) => {
    if (closeTheDrawer) {
      closeTaskDrawer();
    }
    searchUserTasksQuery.refetch();
  };

  const handleNotes = (event, record) => {
    event?.stopPropagation();
    //setIsNotesDrawerVisible(true);
    //setNotesConfig({ patient: record?.patient, task: record });
  };

  const onTableChange = (pagination, filters, sorter) => {
    const { current } = pagination;
    const { order, columnKey } = sorter;
    const _variables = {
      ...variables,
      offset: current * variables.limit - variables.limit,
    };
    if (columnKey) {
      if (!order) {
        _variables["sortOrder"] = ["-createdAt"];
      } else {
        _variables["sortOrder"] = [
          order === "ascend" ? `${columnKey}` : `-${columnKey}`,
        ];
      }
    }
    setCurrentPage(current);
    setVariables(_variables);
  };

  let columns = [
    {
      id: "notes",
      title: "",
      dataIndex: "",
      hidden: !canViewNotesWidget || !shouldShowCreateNotes,
      render: (_, record) => (
        <PlusCircleOutlined
          className="icon-class"
          style={{
            verticalAlign: "middle",
            marginRight: 7,
            fontSize: 20,
            color: "#71afb4",
          }}
          onClick={(event) => handleNotes(event, record)}
          rev={undefined}
        />
      ),
    },
  ];

  columns = isMobile
    ? columns.concat(mobileColumns)
    : columns
      .concat(desktopColumns)
      ?.filter((i) => (i ? i["hidden"] !== true : false));

  const tableEmptyState = {
    emptyText: (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description="No Data with current filter selection"
      />
    ),
  };

  const searchUserTasksQuery = useQuery(SEARCH_USER_TASKS_QUERY, {
    variables,
    fetchPolicy: "no-cache",
    //skip: !variables.organizationId || !variables.appId,
  });

  useEffect(() => {
    setVariables({ ...variables, organizationId, archived: archived });
  }, [archived, organizationId]);

  useEffect(() => {
    let items = [];
    if (taskId) {
      setShowSidebar(false);
      // let item = getUserTasksQuery?.data?.getUserTaskForWidget;
      // items = item ? [item] : [];
      //setTotal(1);
    } else {
      items = searchUserTasksQuery?.data?.searchUserTasks?.items ?? [];
      setTotal(searchUserTasksQuery?.data?.searchUserTasks?.total ?? 0);
    }

    items = items
      ?.filter((item) => !!item)
      ?.map((item) => {
        return { ...item, key: item.id };
      });
    setDataSource(items);
  }, [searchUserTasksQuery, taskId]);



  return (
    <div>
      {hideFilter ? (
        <DefaultTable
          columns={taskDrawerOpen ? closedColumns : columns}
          dataSource={dataSource}
          pagination={{
            current: currentPage,
            total,
            pageSize: variables.limit,
          }}
          locale={tableEmptyState}
          onChange={onTableChange}
          loading={searchUserTasksQuery?.loading}
          onRow={(record: any, rowIndex: number) => {
            return {
              onClick: () => {
                openTaskDrawer(record.id);
              },
              "data-cy": `row-${rowIndex}`,
            };
          }}
        />
      ) : (
        <SplitViewComponent
          onToggle={() => setShowSidebar(!showSidebar)}
          sidebar={
            <FilterSideViewComponent>
              <UserTaskFilters
                //organization={organization}
                organizationId={organizationId}
                archived={archived}
                variables={variables}
                setVariables={setVariables}
                searchUserTasksQuery={searchUserTasksQuery}
                setCurrentPage={setCurrentPage}
              />
            </FilterSideViewComponent>
          }
          showSidebar={showSidebar}
        >
          <DefaultTable
            columns={taskDrawerOpen ? closedColumns : columns}
            dataSource={dataSource}
            pagination={{
              current: currentPage,
              total,
              pageSize: variables.limit,
            }}
            locale={tableEmptyState}
            onChange={onTableChange}
            loading={searchUserTasksQuery?.loading}
            onRow={(record, rowIndex) => {
              return {
                onClick: () => {
                  openTaskDrawer(record.id);
                },
                "data-cy": `row-${rowIndex}`,
              };
            }}
          />
        </SplitViewComponent>
      )}

      { taskDrawerOpen && 
        <UserTaskViewDrawer
          //canManagePolicy={canManagePolicy}
          userTaskId={userTaskId}
          organizationId={organizationId}
          showTaskDrawer={taskDrawerOpen}
          onClose={closeTaskDrawer}
          itsTimeToSave={itsTimeToSave}
          resetTheTimer={resetTheTimer}
          afterUpdate={afterUpdate}
          //viewerData={currentAccount}
          userTaskPageSettings={userTaskPageSettings}
          isMobile={false}
          //appSyncConfig={AppSyncConfig}
          widgetSettings={widgetSettings}
        />
}
      <div ref={drawerContainerRef} className="notes-drawer-form" />
    </div>
  );
};

export default UserTasksTable;
